import React from 'react'
import { Box, Container, Typography } from '@mui/material'

const TermsPage: React.FC = () => {
  return (
    <Box sx={{ py: 8 }}>
      <Container maxWidth="md">
        <Typography variant="h3" gutterBottom sx={{ fontWeight: 700, color: '#8B4513' }}>
          Terms of Service
        </Typography>
        <Typography variant="subtitle1" sx={{ color: '#666', mb: 4 }}>
          Coming Soon
        </Typography>
        <Typography variant="body1" sx={{ color: '#444' }}>
          Our Terms of Service are currently being drafted. Please check back soon for details on
          the terms and conditions governing your use of CigarTrack.
        </Typography>
      </Container>
    </Box>
  )
}

export default TermsPage
